// client/src/pages/Register.js
import React from 'react';
import RegisterForm from '../components/RegisterForm';
import '../styles/Login.css'; // Reusing the same CSS since styles are identical

function Register() {
  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Account anlegen</h1>
          <p className="text-muted">Registriere dich um mit der Analyse deiner Investments zu beginnen!</p>
        </div>
        <RegisterForm />
      </div>
    </div>
  );
}

export default Register;